"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
// text field
var styleOverrides = {
    root: function(param) {
        var theme = param.theme;
        return _define_property({
            fontSize: theme.typography.body2.fontSize
        }, "&.".concat(_material.inputClasses.root, ".").concat(_material.inputClasses.disabled, ":before"), {
            borderBottomStyle: 'solid'
        });
    },
    input: {
        '&&:-webkit-autofill': {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }
};
var defaultProps = {
    color: 'inputElements'
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiInputBase.js.map
